export default __webpack_public_path__ + "static/media/cc.df63c31b.svg";